(() => {
 const section = document.querySelector('[data-calendar-product]');
 if (!section) return;
 const form = section.querySelector('.sd-buy-form');
 const add = form.querySelector('.sd-add');
 const sticky = document.querySelector('[data-calendar-sticky]');
 let initialized = false;
 let interacted = false;
 section.addEventListener('pointerdown', event => { if (event.target.closest('.kaching-bundles__block')) interacted = true; }, {capture:true});
 section.addEventListener('keydown', event => { if (event.target.closest('.kaching-bundles__block')) interacted = true; }, {capture:true});
 function sync() {
  const block = section.querySelector('.kaching-bundles__block');
  const first = block?.querySelector('.kaching-bundles__bar-main');
  if (first && !initialized) {
   initialized = true;
   if (!interacted) first.click();
   section.classList.add('calendar-bundles-ready');
  }
  const price = block?.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price')?.textContent.trim();
  if (price && !form.dataset.drawerBusy && !add.disabled) {
   const label = 'Add to bag — ' + price;
   if (add.textContent !== label) add.textContent = label;
   const total = sticky?.querySelector('[data-calendar-total]');
   if (total && total.textContent !== price + ' ' + section.dataset.currency) total.textContent = price + ' ' + section.dataset.currency;
  }
 }
 const observer = new MutationObserver(sync);
 observer.observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['class','disabled']});
 sync();
 sticky?.querySelector('[data-calendar-add]').addEventListener('click', () => { if (!add.disabled) form.requestSubmit(add); });
 const visibility = new IntersectionObserver(entries => { if(sticky) sticky.hidden = entries[0].isIntersecting; });
 visibility.observe(add);
 document.querySelector('a[href="#calendar-delivery"]')?.addEventListener('click', () => { section.querySelector('#calendar-delivery').open = true; });
})();
